export default __webpack_public_path__ + "static/media/DotGrey.d8525517.svg";